import React from 'react'

export default function Result(props) {
  return (
    <div className=' flex justify-center flex-col'>
        <div>

        {props.verdict?
    "congratulations you won!":
    "better luck next time :("    
    }
        </div>
    <div className='w-48 justify-self-auto m-4'>
        <img src={`/char/${props.char}.gif`} alt="" />
    </div>
    </div>
  )
}
